module.exports = __webpack_public_path__ + "static/comfort-1-c3c8c69ab6a422a396573b7d50c63b65.png";